module.exports = __webpack_public_path__ + "static/media/carHub.2f153ad1.jpg";